import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';

import PageHeader from '../../../sharedModules/layout/PageHeader';
import CreateForm from '../../../sharedModules/updateForm/CreateForm';
import { waterAuthorityFormFields } from '../waterAuthorityFormConfig';

const WaterAuthorityCreatePage: FC = () => {
  const history = useHistory();


  const handleSuccess = (createdRecord: Record<any, any>) => {
    if (createdRecord?.id) {
      history.push(`/backflows/water_authorities/${createdRecord.id}`);
    } else {
      history.push('/backflow_tests/water_authority_configurations');
    }
  };

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh', p: 3 }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <PageHeader
            mainTitle="Water Authorities"
            subTitle="Add New Water Authority"
            backButtonLabel="Water Authorities List"
            backButtonLink="/backflow_tests/water_authority_configurations"
          />
        </Grid>
        <Grid item xs={12}>
          <Card elevation={2}>
            <CardContent>
              <CreateForm
                fields={waterAuthorityFormFields}
                modelName="water_authority"
                controller="backflows/water_authorities"
                onSuccess={handleSuccess}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WaterAuthorityCreatePage;
